var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pay-over-page"},[_c('img',{attrs:{"src":require("@/assets/success.png")}}),_c('span',{staticClass:"value"},[_vm._v("支付成功")]),_c('span',{staticClass:"num"},[_vm._v(_vm._s(_vm.num)+"秒后关闭")])])
}
var staticRenderFns = []

export { render, staticRenderFns }